@let isMenuPage = pageIs().menu;
@let isRealSports = pageIs().realSports;
@let isMlseFoundation = pageIs().mlseFoundation;
@let isYourSeatView = pageIs().yourSeatView;

<div
  class="tab-bar"
  [class.hide]="hideTabBar()"
>
  <div class="tabs" coreActivitySection="TabBar">
    <button
      class="tab"
      style="min-width: 194px"
      [class.active]="isMenuPage"
      [routerLink]="isMenuPage ? '/main/home' : '/main/menu'"
      [coreUserActivityClickTracking]="isMenuPage ? 'MenuClose' : 'MenuOpen'"
    >
      <img src="/images/tab-bar/scotia-club-menu.png" alt="Menu" style="width: 162px; height: 48px"/>
    </button>

    <button
      class="tab"
      [class.active]="isRealSports"
      [routerLink]="isRealSports ? '/main/home' : '/main/real-sports'"
      [coreUserActivityClickTracking]="isRealSports ? 'RealSportsPageClose' : 'RealSportsPageOpen'"
    >
      <img src="/images/tab-bar/real-sports-auction.png" alt="Real Sports Auction" style="width: 115px; height: 81px"/>
    </button>

    <button
      class="tab"
      [class.active]="isMlseFoundation"
      [routerLink]="isMlseFoundation ? '/main/home' : '/main/mlse-foundation'"
      [coreUserActivityClickTracking]="isMlseFoundation ? 'MlseFoundationPageClose' : 'MlseFoundationPageOpen'"
    >
      <img src="/images/tab-bar/mlse-foundation.png" alt="MLSE Foundation" style="width: 77px; height: 68px"/>
    </button>

    <button
      class="tab"
      [class.active]="isYourSeatView"
      [routerLink]="isYourSeatView ? '/main/home' : '/main/your-seat-view'"
      [coreUserActivityClickTracking]="isYourSeatView ? 'YourSeatViewPageClose' : 'YourSeatViewPageOpen'"
    >
      <img src="/images/tab-bar/your-seat-view.png" alt="Your Seat View" style="width: 142px; height: 48px"/>
    </button>
  </div>
</div>

@if (hideTabBar()) {
  <core-interacts-present/>
}
